// Configuraciones del servidor
const env = {
  //API_URL: 'http://172.20.50.23:8000/api/v1/', // URL servidor de API's
  //API_URL: 'http://prgsolicitudes.test:9090/api/v1/', // URL servidor de API's
  API_URL: 'https://solicitudes.pragmainvest.com.bo/api/v1/', // URL servidor de API's
  //SERVER_URL: 'http://172.20.50.23:8000/', // URL servidor para recuperar archivos
  //SERVER_URL: 'http://prgsolicitudes.test:9090/', // URL servidor para recuperar archivos
  SERVER_URL: 'https://solicitudes.pragmainvest.com.bo/', // URL servidor para recuperar archivos
  FINGERPRINT_AUTH: 'pr46m4_2022', // Clave para autenticar por huella, DEBER SER LA MISMA CONFIGURADA EN EL SERVIDOR
  VERSION_ANDROID: '1.3.2',
  VERSION_IOS: '1.0.3'
}

export default env;